import { isValid } from '@pages/Client/Calendar/components/BulkEdit/helpers/isValidValidationNumber';

export function isMoreThanTenPercent(value?: number, baseValue?: number) {
  if (isNaN(Number(value)) || isNaN(Number(baseValue))) return true;
  return isValid(value) && isValid(baseValue) ? Number(value) > 0.1 * Number(baseValue) : false;
}
